export default "__VITE_ASSET__DTyGqcx7__"